export default {
    "fr": {
        "Customs": "Douane",
        "Shipping agent": "Agent maritime",
        "Our values": "Nos valeurs",
        "Group": "Le groupe",
        "Contact us": "Contact",
        "Register": "M'inscrire",
        "Login": "Me connecter",
        "Account": "Compte",
        "My account": "Mon compte",
        "Clerks": "Commis",
        "Registered Customs Representative": "Représentant en Douane Enregistré",
        "Assistance with formalities": "Assistance des formalités douanières",
        "Assistance and management": "Assistance et pilotage.",
        "Declarations and formalities": "Déclarations et formalités",
        "Sanitary inspections – veterinarians": "Inspections sanitaires - vétérinaires.",
        "Live animals – Horses": "Animaux vivants - Chevaux",
        "Veterinary checks": "Contrôles vétérinaires",
        "Transit": "Transit",
        "Customs transit – CTS": "Transit douanier - CTS",
        "Quality and Qualification": "Qualité & Qualification",
        "Customs certifications": "Les certifications douane.",
        "Port locations": "Implantations port",
        "The locations of the ASA group": "Les implantations du groupe ASA.",
        "FAQ": "FAQ",
        "We answer your questions": "Nous répondons à vos questions",
        "Our network": "Notre réseau",
        "Find our partners": "Retrouvez nos partenaires",
        "Agent": "Agent",
        "Our services and benefits": "Nos services et prestations",
        "Tramping - Coasting": "Tramping - Cabotage",
        "Charters on request": "Affrêtements sur demande",
        "Our references and qualifications": "Nos références et qualifications",
        "Our expertise": "Notre expertise",
        "Glossary": "Glossaire",
        "Terms": "Termes douaniers",
        "Consignment": "Consignation"
    },
    "en": {
        "Customs": "Customs",
        "Shipping agent": "Maritime agent",
        "Our values": "Our values",
        "Group": "Group",
        "Contact us": "Contact us",
        "Register": "Register",
        "Login": "Login",
        "Account": "Account",
        "My account": "My account",
        "Clerks": "Clerks",
        "Registered Customs Representative": "Registered Customs Representative.",
        "Assistance with formalities": "Assistance with formalities",
        "Assistance and management": "Assistance and management",
        "Declarations and formalities": "Declarations and formalities",
        "Sanitary inspections – veterinarians": "Sanitary inspections – veterinarians",
        "Live animals – Horses": "Live animals – Horses",
        "Veterinary checks": "Veterinary checks",
        "Transit": "Transit",
        "Customs transit – CTS": "Customs transit – CTS",
        "Quality and Qualification": "Quality and Qualification",
        "Customs certifications": "Customs certifications",
        "Port locations": "Port locations",
        "The locations of the ASA group": "The locations of the ASA group",
        "FAQ": "FAQ",
        "We answer your questions": "We answer your questions",
        "Our network": "Our network",
        "Find our partners": "Find our partners",
        "Agent": "Agent",
        "Our services and benefits": "Our services and benefits",
        "Tramping - Coasting": "Tramping - Coasting",
        "Charters on request": "Charters on request",
        "Our references and qualifications": "Our references and qualifications",
        "Our expertise": "Our expertise",
        "Terms": "Customs terms",
        "Glossary": "Glossary",
        "Consignment": "Consignment"
    }
}
